import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FormService } from 'src/app/_core/services/form.service';
import { email } from 'src/app/_core/utils/helpers/validators';

export type RestorePasswordForm = {
  email: FormControl<string>;
};

@Injectable({ providedIn: 'root' })
export class RestorePasswordFormService extends FormService<RestorePasswordForm> {
  constructor() {
    super();

    this.form = this.fb.group<RestorePasswordForm>({
      email: this.fb.control('', [
        email,
        Validators.required,
        Validators.maxLength(100),
      ]),
    });
  }
}
